import { SVGWrapper } from '../SVGWrapper';

const JIRAIcon = SVGWrapper(() => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5029 0H5.72563C5.72563 1.44007 6.89113 2.60612 8.33151 2.60612H9.394V3.63442C9.394 5.07449 10.56 6.24054 12 6.24054V0.497148C11.9999 0.365327 11.9475 0.238933 11.8543 0.145721C11.7611 0.0525092 11.6347 9.93255e-05 11.5029 0Z"
        fill="#2684FF"
      />
      <path
        d="M8.64016 2.88047H2.86279C2.86279 4.32041 4.02841 5.48646 5.46828 5.48646H6.53128V6.51476C6.53128 7.95483 7.69728 9.12088 9.13728 9.12088V3.37749C9.13708 3.2457 9.08464 3.11936 8.99146 3.02617C8.89827 2.93298 8.77194 2.88067 8.64016 2.88047Z"
        fill="url(#paint0_linear_24920_97357)"
      />
      <path
        d="M5.77737 5.75946H0C0 7.20003 1.1655 8.36558 2.606 8.36558H3.66849V9.39438C3.66849 10.8344 4.83449 12 6.27437 12V6.25711C6.27423 6.12528 6.22184 5.99889 6.12868 5.90563C6.03552 5.81237 5.90918 5.75972 5.77737 5.75946Z"
        fill="url(#paint1_linear_24920_97357)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_24920_97357"
          x1="11.77"
          y1="0.0127396"
          x2="7.04257"
          y2="4.86072"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.176" stop-color="#0052CC" />
          <stop offset="1" stop-color="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_24920_97357"
          x1="6.32049"
          y1="5.78163"
          x2="3.47836"
          y2="8.54663"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.176" stop-color="#0052CC" />
          <stop offset="1" stop-color="#2684FF" />
        </linearGradient>
      </defs>
    </svg>
  );
});

export default JIRAIcon;
